module.exports = __webpack_public_path__ + "img/retention-framework.b46ee375.svg";